import React from 'react';
import { Button } from 'components';
import { Col, Row, Typography } from 'components';
import { EditIconButton } from 'components/common/icons';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';
import styles from '../styles.module.scss';
import { User } from 'models/User';

type AssignmentProps = {
  isFinalStatus: boolean;
  assignmentData: {
    role: string;
    data: User;
  }[];
  onUpdateAssignmentClick: () => void;
};

export const Assignment: React.FC<AssignmentProps> = ({ isFinalStatus, assignmentData, onUpdateAssignmentClick }) => {
  return (
    <HasAccess role={PERMISSIONS.deals.assignment.read}>
      <Col span={24} className={`${styles.main_info} ${styles.border_bottom_none}`}>
        <Row justify={'space-between'}>
          <Col>
            <Typography.Text strong className={'font-size-16'}>
              Assignments
            </Typography.Text>
          </Col>
          <Col>
            <HasAccess role={PERMISSIONS.deals.assignment.write}>
              {!isFinalStatus ? (
                <Button type={'link'} icon={<EditIconButton />} onClick={onUpdateAssignmentClick} />
              ) : (
                ''
              )}
            </HasAccess>
          </Col>
        </Row>
        <Row gutter={[0, 12]} className={'margin-t-12'}>
          {assignmentData.map(({ role, data }) => (
            <Col span={24} key={role}>
              <Row gutter={[12, 12]} justify={'space-between'} wrap={false}>
                <Col flex="none">
                  <Typography.Text ellipsis={{ tooltip: true }} className={'font-size-14'} type={'secondary'}>
                    {role}
                  </Typography.Text>
                </Col>
                <Col flex="auto" style={{ textAlign: 'right' }}>
                  <Typography.Text ellipsis={{ tooltip: true }} className={'font-size-14'} type={'secondary'}>
                    {data?.firstName ? `${data?.firstName} ${data?.lastName}` : 'Not Set'}
                  </Typography.Text>
                </Col>
              </Row>
            </Col>
          ))}
        </Row>
      </Col>
    </HasAccess>
  );
};
